<div class="form-group">
  <div class="form-control content-date">
    <label for="requestDate">{{ 'Data de ' + title | translate }}</label>
    <div class="form-group">
       
        <p-calendar dateFormat="dd/mm/yy" name="requestDate" [readonlyInput]="true" [minDate]="minDate"
          appendTo="body" [(ngModel)]="newDate" [showIcon]="true" i18n [disabled]="started"
          (onSelect)="changeDateByCalendar(newDate)" required styleClass="forecast-date">
        </p-calendar>
        <div class="day-name">
          <span>{{newDate | date:'EEE':'pt-BR'}}</span>
      </div>
    </div>
  </div>
  <div class="form-control content-time">
    <label>{{ 'Hr ' + title | translate }}</label>
    <div style="display: flex; align-items: center; margin-top: 4px;">
      <p-dropdown placeholder="Selecione..." [options]="availablePeriods"
        [(ngModel)]="selectedPeriods"
        appendTo="body" name="executionForecast" [required]="!manualHour"
        [disabled]="started || !availablePeriods || availablePeriods.length <= 0"
        (onChange)="selectDateTime($event)" *ngIf="!manualHour && availablePeriods" style="flex: 1;">
      </p-dropdown>
      <input class="width-input" pInputText type="time" [style]="{display: 'block', width: '100%'}" name="executionForecast"
        [(ngModel)]="dateManual" [required]="manualHour"
        [disabled]="started"
        (blur)="selectManualDateTime($event, dateManual);"
        *ngIf="manualHour" style="flex: 1;">
      <button pButton type="button" icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-sm" 
        [disabled]="started" (click)="manualHour = !manualHour; onChangeManual({originalEvent: {isTrusted: true}, checked: !manualHour})" 
        style="margin-left: 5px;" [ngClass]="{'p-button-info': manualHour}"
        pTooltip="{{manualHour ? 'Voltar para seleção automática' : 'Editar horário manualmente'}}" tooltipPosition="top">
      </button>
      <span style="color: red; margin-left: 5px;" *ngIf="manualHourRequired">*</span>
    </div>
  </div>

</div>
